import { render, staticRenderFns } from "./MotorOwnerDetails.vue?vue&type=template&id=a31538ba&"
import script from "./MotorOwnerDetails.vue?vue&type=script&lang=js&"
export * from "./MotorOwnerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports